import React, { useState, useEffect } from "react";
import MaintenanceCard from "./MaintenanceCard";
import { useMutation } from "react-query";
import { usePopup } from "../../common/contexts/PopupContext";
import useMaintenance from "../../common/hooks/pages/useMaintenance";
import useIncidents from "../../common/hooks/pages/useIncidents";
import { Link, useNavigate, useParams } from "react-router-dom";

const Updates = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { toast } = usePopup();
  const [formClose, setFormClose] = useState(false);
  const { maintenanceUpdate } = useMaintenance();
  const { getMaintenance } = useIncidents();

  const {
    data: maintenanceDataResponse,
    isLoading: isGetting,
    mutate: getMaintenanceMutate,
  } = useMutation({
    mutationFn: getMaintenance,
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while getting Maintenance!";
      toast(message, "error");
    },
  });

  useEffect(() => {
    if (id) {
      getMaintenanceMutate(id);
    }
  }, [id]);

  const maintenanceData = maintenanceDataResponse?.data?.maintenance || {};

  const { mutate: maintenanceUpdateMutate } = useMutation({
    mutationFn: maintenanceUpdate,
    onSuccess: (res) => {
      const { message } = res?.data || {};

      toast(message, "success");
      getMaintenanceMutate(id);
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while updating Maintenance!";
      toast(message, "error");
    },
  });

  if (!maintenanceData) {
    return null;
  }

  const { updates, _id } = maintenanceData;

  function formatDate(dateString, type) {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const date = new Date(dateString);

    const monthName = months[date.getMonth()];
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    const timezone = Intl.DateTimeFormat(undefined, {
      timeZoneName: "short",
    }).format(date);

    const timeArray = timezone?.split(",");
    const zoneArray = timeArray[1]?.split("+");

    const formattedDate = `${monthName} ${day}, ${year}`;
    const formattedTimezone = ` - ${hours}:${minutes} ${
      zoneArray[0] ? zoneArray[0] : ""
    }`;

    if (type == "date") {
      const formattedDateTimezone = `${formattedDate}`;
      return formattedDateTimezone;
    }
    if (type == "dateonly") {
      const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}`;
      return formattedDate;
    } else {
      const formattedDateTimezone = `${formattedDate}  ${formattedTimezone}`;
      return formattedDateTimezone;
    }
  }

  const formatDateDifference = (previousDate) => {
    const currentDate = new Date();
    const prevDate = new Date(previousDate);
    const timeDifference = currentDate.getTime() - prevDate.getTime();

    const secondsDifference = Math.floor(timeDifference / 1000);
    const minutesDifference = Math.floor(secondsDifference / 60);
    const hoursDifference = Math.floor(minutesDifference / 60);
    const daysDifference = Math.floor(hoursDifference / 24);

    if (daysDifference > 0) {
      return `${daysDifference} days ago`;
    } else if (hoursDifference > 0) {
      return `${hoursDifference} hours ago`;
    } else if (minutesDifference > 0) {
      return `${minutesDifference} minutes ago`;
    } else {
      return `${secondsDifference} seconds ago`;
    }
  };

  const handleSubmit = (id, maintenanceId, updatedDate, updatedMessage) => {
    maintenanceUpdateMutate({
      id: id,
      maintenanceId: maintenanceId,
      date: updatedDate,
      message: updatedMessage,
    });
  };
  return (
    <div>
      <div className="text-1xl font-bold">Update History</div>
      <div className="mt-6 flex flex-col space-y-4">
        {updates?.map((update) => {
          let msg = "";
          if (update.status.label === "Scheduled") {
            msg = " The scheduled maintenance has been completed.";
          } else if (update.status.label === "In Progress") {
            msg =
              " Scheduled maintenance is currently in progress. We will provide updates as necessary.";
          } else if (update.status.label === "Completed") {
            msg = "The scheduled maintenance has been completed.";
          }
          let updatedAt = formatDate(update?.updatedAt);
          let dateDiff = formatDateDifference(update?.updatedAt);
          let happenedAt = formatDate(update?.happenedAt, "dateonly");
          return (
            <MaintenanceCard
              submitHandler={handleSubmit}
              key={update._id}
              update={update}
              msg={msg}
              happenedAt={happenedAt}
              dateDiff={dateDiff}
              formClose={formClose}
              updatedAt={updatedAt}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Updates;
